import { fetchFactory, postMultipart, serializeParts } from 'isotope-client'
import { buildUrlWithParams } from 'isotope-client/utils/urlUtils'

export const saveMoTache = (values) => postMultipart('/bo/modeleTache', {
	body: serializeParts([{ key: 'form', value: values }, { key: 'instructions', value: values.instructions }])
})

export const getAllBlocs = (idFerme) => fetchFactory(buildUrlWithParams('/planche/blocs', { idFerme }))

/**
 * Récupère une éventuelle tâche de recalcul en cours
 * @return {Promise<*>}
 */
export const getPendingRecalcul = () => fetchFactory(`/taskInProgress?type=RECALCUL_TACHE`)